import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-background-dark border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Tagline */}
          <div className="col-span-1">
            <img 
              src="/logo.svg" 
              alt="Star Nivesh" 
              className="h-[110px] w-auto"
            />
            <p className="text-text-secondary mb-4">
              Your Goals, My Mission
            </p>
            <p className="text-text-muted text-sm">
              Professional mutual fund distribution services focused on goal-based investing for retail and corporate clients.
            </p>
            <p className="text-text-muted text-sm">
              <li className="list-none">
                <Link 
                  to="https://www.amfiindia.com/locate-distributor" 
                  className="text-text-secondary hover:text-primary transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AMFI Registration Number: 290244
                </Link>
              </li>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-text-primary font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/philosophy" className="text-text-secondary hover:text-primary transition-colors">Our Approach</Link></li>
              <li><Link to="/services/retail" className="text-text-secondary hover:text-primary transition-colors">Retail Services</Link></li>
              <li><Link to="/services/corporate" className="text-text-secondary hover:text-primary transition-colors">Corporate Services</Link></li>
              <li><Link to="/contact" className="text-text-secondary hover:text-primary transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Calculators */}
          <div>
            <h3 className="text-text-primary font-semibold mb-4">Calculators</h3>
            <ul className="space-y-2">
              <li><Link to="/calculators/sip" className="text-text-secondary hover:text-primary transition-colors">SIP Calculator</Link></li>
              <li><Link to="/calculators/swp" className="text-text-secondary hover:text-primary transition-colors">SWP Calculator</Link></li>
              <li><Link to="/calculators/retirement" className="text-text-secondary hover:text-primary transition-colors">Retirement Calculator</Link></li>
              <li><Link to="/calculators/fire" className="text-text-secondary hover:text-primary transition-colors">FIRE Calculator</Link></li>
              <li><Link to="/calculators/goal" className="text-text-secondary hover:text-primary transition-colors">Goal Planner</Link></li>
              <li><Link to="/calculators/emi" className="text-text-secondary hover:text-primary transition-colors">EMI Calculator</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-text-primary font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/blogs" className="text-text-secondary hover:text-primary transition-colors">Blogs</Link></li>
              <li><Link to="/book-summaries" className="text-text-secondary hover:text-primary transition-colors">Book Summaries</Link></li>
              <li><Link to="/books" className="text-text-secondary hover:text-primary transition-colors">Books</Link></li>
            </ul>
          </div>
        </div>

        {/* Social Media and Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center">
          <p className="text-text-muted text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Star Nivesh. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors" data-testid="social-linkedin">
              <Linkedin size={24} />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors" data-testid="social-facebook">
              <Facebook size={24} />
            </a>
            <a href="https://instagram.com/starnivesh" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors" data-testid="social-instagram">
              <Instagram size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
